import { graphql } from 'gql';

export const ArchiveAccessInfo_ArtistLabelSubscriptionFragment = graphql(`
  fragment ArchiveAccessFields on ArtistLabelSubscription {
    archiveAccessExpiresAt
    archiveAccessGrantedAt
    hasArchiveAccess
    label {
      id
      name
    }
  }
`);

export const GrantArchiveAccess = graphql(`
  mutation grantArchiveAccess($labelId: ID!, $artistId: ID!) {
    archiveAccessGrant(input: { artistId: $artistId, labelId: $labelId }) {
      artistLabelSubscription {
        ...ArchiveAccessFields
      }
      errors
    }
  }
`);

export const RenewArchiveAccess = graphql(`
  mutation renewArchiveAccess($labelId: ID!, $artistId: ID!) {
    archiveAccessRenew(input: { artistId: $artistId, labelId: $labelId }) {
      artistLabelSubscription {
        ...ArchiveAccessFields
      }
      errors
    }
  }
`);

export const RevokeArchiveAccess = graphql(`
  mutation revokeArchiveAccess($labelId: ID!, $artistId: ID!) {
    archiveAccessRevoke(input: { artistId: $artistId, labelId: $labelId }) {
      artistLabelSubscription {
        ...ArchiveAccessFields
      }
      errors
    }
  }
`);

export const GetLabelSubscribers = graphql(`
  query getLabelSubscribers(
    $labelId: ID!
    $page: Int
    $perPage: Int
    $sortBy: LabelSubscriberOrderInput
    $filterBy: LabelSubscriberFilterInput
  ) {
    label(id: $labelId) {
      id
      subscribers(page: $page, perPage: $perPage, filterBy: $filterBy, orderBy: $sortBy) {
        pageInfo {
          page
          pageCount
          nodeCount
          perPage
          hasNextPage
        }
        edges {
          id
          addedAt
          lastReactedAt
          hasArchiveAccess
          archiveAccessExpiresAt
          archiveAccessGrantedAt
          averageRating
          hasPromoAccess
          isFollowing
          node {
            id
            name
            slug
            spotifyPopularity
            image {
              url
            }
          }
        }
      }
    }
  }
`);
